import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

/**
 * Hook to automatically cleanup expired custom metrics for non-premium users
 * Runs once when the user session is established
 */
export const useCustomMetricsCleanup = (userId: string | undefined) => {
  useEffect(() => {
    if (!userId) return;

    const cleanupExpiredMetrics = async () => {
      try {
        const { data, error } = await supabase.rpc("cleanup_expired_custom_metrics", {
          p_user_id: userId,
        });

        if (error) {
          console.error("[CustomMetricsCleanup] Error:", error);
          return;
        }

        // If any metrics were deleted, log it
        if (data && data.length > 0) {
          const deletedCount = data[0]?.deleted_count || 0;
          if (deletedCount > 0) {
            console.log(`[CustomMetricsCleanup] Deleted ${deletedCount} expired custom metrics`);
          }
        }
      } catch (err) {
        console.error("[CustomMetricsCleanup] Unexpected error:", err);
      }
    };

    // Run cleanup on mount
    cleanupExpiredMetrics();

    // Optional: Run cleanup periodically (e.g., every hour while user is active)
    const interval = setInterval(cleanupExpiredMetrics, 60 * 60 * 1000); // 1 hour

    return () => clearInterval(interval);
  }, [userId]);
};
